import PropTypes from 'prop-types';
import React from 'react';

export default function DynamicHeightHTMLColumn({ cell, expandedRowIndex, rowIndex, updateExpandedRowIndex }) {
  function getShowMoreLessLink(text, onShowMoreLessClick) {
    return (
      <a className="show-more-link" onClick={onShowMoreLessClick}>
        {' '}
        {text}
      </a>
    );
  }

  function joinArray(array, delimiter) {
    if (delimiter) {
      return array.length > 0 ? array.reduce((result, item) => [result, delimiter, item]) : null;
    }
    return array;
  }

  function getValueToRender() {
    if (cell.value.length > cell.itemsToShow) {
      if (expandedRowIndex !== rowIndex) {
        return {
          valueToRender: joinArray(cell.value.slice(0, cell.itemsToShow), cell.delimiter),
          link: getShowMoreLessLink(cell.showMoreLink || 'Show more', () => updateExpandedRowIndex(rowIndex)),
        };
      }
      return {
        valueToRender: joinArray(cell.value, cell.delimiter),
        link: getShowMoreLessLink(cell.showLessLink || 'Show less', () => updateExpandedRowIndex(-1)),
      };
    }
    return {
      valueToRender: joinArray(cell.value, cell.delimiter),
      link: '',
    };
  }

  const { valueToRender, link } = getValueToRender();

  return (
    <div className="dynamic-height-column">
      {cell.staticValue && <div>{cell.staticValue}</div>}
      <div>
        {valueToRender}
        {link}
      </div>
    </div>
  );
}

DynamicHeightHTMLColumn.propTypes = {
  cell: PropTypes.shape({
    value: PropTypes.array,
    itemsToShow: PropTypes.number,
    staticValue: PropTypes.string,
    delimiter: PropTypes.string,
    showMoreLink: PropTypes.element,
    showLessLink: PropTypes.element,
  }).isRequired,
};

DynamicHeightHTMLColumn.defaultProps = {
  cell: PropTypes.shape({
    delimiter: '',
  }),
};
